import { createStore, applyMiddleware, compose } from "redux"
import thunk from "redux-thunk"
import { fromJS } from "immutable"
import createReducer from "./reducers/index"
import { createLogger } from "redux-logger"

export default function configureStore(initialState) {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

    const store = createStore(
        createReducer(),
        fromJS(initialState),
        composeEnhancers(
            applyMiddleware(
                thunk,
                createLogger({ collapsed: true })
            )
        )
    )

    return store
}



// WEBPACK FOOTER //
// ./src/configureStore.js